import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { verifyToken } from '../services/api';
import MaterialIcon from './MaterialIcon';

const Layout = ({ children, setIsAuthenticated, darkMode, toggleDarkMode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  // Load permissions from localStorage on mount to prevent menu flickering
  const [permissions, setPermissions] = useState(() => {
    try {
      const cached = localStorage.getItem('admin_permissions');
      return cached ? JSON.parse(cached) : [];
    } catch {
      return [];
    }
  });
  const [adminUsername, setAdminUsername] = useState(() => {
    try {
      return localStorage.getItem('admin_username') || '';
    } catch {
      return '';
    }
  });

  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const response = await verifyToken();
        if (response.success && response.admin) {
          const newPermissions = response.admin.permissions || [];
          const newUsername = response.admin.username || '';
          setPermissions(newPermissions);
          setAdminUsername(newUsername);
          // Cache permissions and username to localStorage
          localStorage.setItem('admin_permissions', JSON.stringify(newPermissions));
          localStorage.setItem('admin_username', newUsername);
        }
      } catch (error) {
        console.error('Error fetching admin data:', error);
      }
    };
    fetchAdminData();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('admin_permissions');
    localStorage.removeItem('admin_username');
    localStorage.removeItem('admin_role');
    setIsAuthenticated(false);
    navigate('/login');
  };

  const allNavItems = [
    { id: 'workflows', path: '/workflows', label: 'Workflows', icon: 'graph_1' },
    { id: 'webhooks', path: '/webhooks', label: 'Webhooks', icon: 'webhook' },
    { id: 'ai-connectors', path: '/ai-connectors', label: 'AI Connectors', icon: 'smart_toy' },
    { id: 'admins', path: '/admins', label: 'Admins', icon: 'person' },
  ];

  // Filter menu items based on permissions
  const navItems = allNavItems.filter(item => permissions.includes(item.id));

  return (
    <div className="layout">
      <div className="sidebar">
        <div className="sidebar-header">
          <h2>
            Wokkio
          </h2>
          {adminUsername && (
            <p style={{ fontSize: '0.85em', opacity: 0.7 }}>
              <MaterialIcon icon="person" size={16} style={{ verticalAlign: 'middle', marginRight: '4px' }} />
              {adminUsername}
            </p>
          )}
        </div>
        <ul className="sidebar-nav">
          {navItems.map((item) => (
            <li key={item.path}>
              <Link 
                to={item.path} 
                className={location.pathname === item.path ? 'active' : ''}
              >
                <MaterialIcon icon={item.icon} size={20} style={{ flexShrink: 0 }} />
                {item.label}
              </Link>
            </li>
          ))}
          <li className="sidebar-nav-divider" aria-hidden="true" />
          <li>
            <Link
              to="/settings"
              className={location.pathname === '/settings' ? 'active' : ''}
            >
              <MaterialIcon icon="settings" size={20} style={{ flexShrink: 0 }} />
              Settings
            </Link>
          </li>
        </ul>
        <div className="sidebar-footer">
          <button type="button" onClick={handleLogout} className="logout-btn">
            <MaterialIcon icon="logout" size={20} style={{ flexShrink: 0 }} />
            Log out
          </button>
        </div>
      </div>
      <div className="main-content">
        {children}
      </div>
    </div>
  );
};

export default Layout;
